document.addEventListener("DOMContentLoaded", async () => {
  console.log("✅ DOM fully loaded");

  const status = document.getElementById("status");
  const scanButton = document.getElementById("scanButton");
  const video = document.getElementById("camera");

  if (!status || !scanButton || !video) {
    console.error("❌ Required DOM elements missing.");
    return;
  }

  scanButton.disabled = true;
  status.textContent = "Loading TensorFlow...";

  // --- Setup camera ---
  async function initCamera() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: { ideal: "environment" } },
        audio: false
      });
      video.srcObject = stream;
      await video.play();
      video.style.display = "block";
      console.log("✅ Camera initialized");
    } catch (err) {
      console.error("❌ Camera error:", err);
      status.textContent = "Camera access failed.";
    }
  }

  // --- Load MobileNet ---
  async function loadModel() {
    try {
      if (typeof tf === "undefined" || typeof mobilenet === "undefined") {
        throw new Error("TensorFlow or MobileNet not loaded");
      }
      const model = await mobilenet.load();
      console.log("✅ MobileNet loaded");
      status.textContent = "Model loaded.";
      return model;
    } catch (err) {
      console.error("❌ Model load error:", err);
      status.textContent = "Model load error.";
      return null;
    }
  }

  // --- Wait for trigger images to actually render ---
  async function loadTriggerImages() {
    const imgs = Array.from(document.querySelectorAll("#trigger-images img"));
    if (imgs.length === 0) {
      console.warn("⚠️ No triggers found in HTML.");
      status.textContent = "⚠️ No triggers found.";
      return [];
    }
    await Promise.all(
      imgs.map(
        (img) =>
          new Promise((resolve) => {
            if (img.complete) resolve();
            else img.onload = resolve;
          })
      )
    );
    console.log(`✅ ${imgs.length} trigger images loaded.`);
    return imgs;
  }

  const triggerVideos = Array.from(document.querySelectorAll("#trigger-videos a"));
  console.log(`✅ Found ${triggerVideos.length} trigger videos`);

  const model = await loadModel();
  const triggerImages = await loadTriggerImages();

  // --- Compute embeddings for triggers ---
  const triggerEmbeddings = [];
  if (model && triggerImages.length > 0) {
    for (let i = 0; i < triggerImages.length; i++) {
      try {
        const img = triggerImages[i];
        const tensor = tf.browser.fromPixels(img).resizeBilinear([224, 224]).toFloat().expandDims(0);
        const embedding = model.infer(tensor, true);
        triggerEmbeddings.push(embedding);
        tensor.dispose();
        console.log(`✅ Embedded trigger ${i + 1}: ${img.alt}`);
      } catch (err) {
        console.error(`❌ Error embedding trigger ${i + 1}:`, err);
      }
    }
  }

  // --- Cosine similarity ---
  function cosineSimilarity(a, b) {
    const dot = a.mul(b).sum();
    const normA = a.square().sum().sqrt();
    const normB = b.square().sum().sqrt();
    return dot.div(normA.mul(normB));
  }

  // --- Play trigger video ---
  function playTriggerVideo(index) {
    const link = triggerVideos[index];
    if (link) {
      const videoUrl = link.href;
      const player = document.createElement("video");
      player.src = videoUrl;
      player.autoplay = true;
      player.controls = true;
      player.style.width = "320px";
      player.style.marginTop = "10px";
      document.body.appendChild(player);
      console.log(`🎬 Playing ${videoUrl}`);
      status.textContent = `Playing trigger ${index + 1}`;
    } else {
      status.textContent = "No matching video found.";
    }
  }

  // --- Enable Scan button only when ready ---
  if (model && triggerEmbeddings.length > 0) {
    scanButton.disabled = false;
    status.textContent = "Ready. Press Scan to start camera.";
  } else {
    status.textContent = "Error: Model or triggers not ready.";
    return;
  }

  // --- Scan button ---
  scanButton.addEventListener("click", async () => {
    status.textContent = "Opening camera...";
    await initCamera();

    status.textContent = "Scanning...";
    console.log("📸 Scan button pressed");

    let bestScore = -1;
    let bestIndex = -1;
    const framesToCapture = 3;

    for (let f = 0; f < framesToCapture; f++) {
      const frameTensor = tf.browser.fromPixels(video).resizeBilinear([224,224]).toFloat().expandDims(0);
      const frameEmbedding = model.infer(frameTensor, true);

      for (let i = 0; i < triggerEmbeddings.length; i++) {
        const simTensor = cosineSimilarity(frameEmbedding, triggerEmbeddings[i]);
        const sim = (await simTensor.data())[0];
        simTensor.dispose();
        console.log(`🔍 Frame ${f+1} similarity with trigger ${i+1}: ${sim.toFixed(3)}`);
        if (sim > bestScore) {
          bestScore = sim;
          bestIndex = i;
        }
      }

      frameTensor.dispose();
      frameEmbedding.dispose();
      await new Promise(r => setTimeout(r, 200));
    }

    if (bestScore > 0.85 && bestIndex >= 0) { // threshold adjustable
      playTriggerVideo(bestIndex);
    } else {
      status.textContent = `No trigger match found. Best score: ${bestScore.toFixed(3)}`;
      console.log("❌ No strong match detected");
    }
  });
});
